// M11 helpers for the schema-driven native section form: the blank value a
// new field or item starts with (by its schema type), and the save-time
// cleanup of string lists (blank rows dropped; an emptied list is removed so
// the optional field is simply absent).

export function isStringList(schema) {
  return schema?.type === 'array' && schema.items?.type === 'string'
}

export function isBoolean(schema) {
  return schema?.type === 'boolean'
}

export function isRating(key, schema) {
  return key === 'rating' || schema?.type === 'integer'
}

// undefined means "leave the key out" (an unset optional integer, or an
// image reference that cannot be null and must be chosen).
export function blankValue(key, schema = {}) {
  if (isStringList(schema)) return []
  if (isBoolean(schema)) return false
  if (isRating(key, schema)) return undefined
  if (key.endsWith('_asset_id')) return [].concat(schema.type).includes('null') ? null : undefined
  return ''
}

export function blankObject(keys, schemaFor) {
  return Object.fromEntries(keys.map((key) => [key, blankValue(key, schemaFor(key))]).filter(([, value]) => value !== undefined))
}

function stringList(value) {
  return Array.isArray(value) && value.every((entry) => typeof entry === 'string')
}

function trimObject(object) {
  const result = {}
  Object.entries(object).forEach(([key, value]) => {
    if (key !== 'items' && stringList(value)) {
      const kept = value.filter((entry) => entry.trim() !== '')
      if (kept.length) result[key] = kept
    } else if (key === 'items' && Array.isArray(value)) {
      result[key] = value.map((item) => (item && typeof item === 'object' && !Array.isArray(item) ? trimObject(item) : item))
    } else {
      result[key] = value
    }
  })
  return result
}

export function trimSectionFields(fields) {
  return fields && typeof fields === 'object' ? trimObject(fields) : fields
}
